import type { SignaturePaymentTabProps } from "../../types/tabs";
import { useSignaturePaymentTab } from "../../hooks/useSignaturePaymentTab";
import styles from "../../styles/applicationDetail.module.css";
import { SignaturePaymentSignatureSection } from "./SignaturePaymentSignatureSection";
import { SignaturePaymentBalanceSections } from "./SignaturePaymentBalanceSections";
import { SignaturePaymentLogSection } from "./SignaturePaymentLogSection";
import { SignaturePaymentFailedAttemptsSection } from "./SignaturePaymentFailedAttemptsSection";
import { SignaturePaymentModals } from "./SignaturePaymentModals";

export function SignaturePaymentTab(props: SignaturePaymentTabProps) {
  const tab = useSignaturePaymentTab(props);

  return (
    <div className={styles.tabContent} data-testid="application-signature-payment-tab-page">
      <SignaturePaymentSignatureSection tab={tab} />
      <SignaturePaymentBalanceSections tab={tab} />
      <SignaturePaymentLogSection tab={tab} />
      <SignaturePaymentFailedAttemptsSection tab={tab} />
      <SignaturePaymentModals tab={tab} />
    </div>
  );
}
